import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { API_URL } from "../../APIRoute";
import { apiCall } from "../../AxiosService";
import { apiResponse } from "../../APIResponse";

export const PasswordVaultgetlist = createAsyncThunk(
  "PasswordVaultgetlist",
  async (data, { dispatch }) => {
    try {
      let resData = await apiCall(
        {
          method: "GET",
          url: API_URL.BASEURL + API_URL.PASSOWORDVAULT.GETLIST,
          body: data,
        },
        true
      );
      let response = apiResponse(false, resData);
      return response;
    } catch (error) {}
  }
);
export const PasswordVaultSave = createAsyncThunk(
  "PasswordVaultSave",
  async (data, { dispatch }) => {
    try {
      let resData = await apiCall(
        {
          method: "POST",
          url: API_URL.BASEURL + API_URL.PASSOWORDVAULT.SAVE,
          body: data,
        },
        true
      );
      let response = apiResponse(true, resData);
      return response;
    } catch (error) {}
  }
);
export const PasswordVaultDetail = createAsyncThunk(
  "PasswordVaultDetail",
  async (data, { dispatch }) => {
    try {
      let resData = await apiCall(
        {
          method: "POST",
          url: API_URL.BASEURL + API_URL.PASSOWORDVAULT.GETBYPRIMARYKEY,
          body: data,
        },
        true
      );
      let response = apiResponse(false, resData);
      return response;
    } catch (error) {}
  }
);
const initialState = {
  PasswordVaultData: {
    data: null,
    error: null,
  },
  PasswordVaultSaveData: {
    data: null,
    error: null,
  },
  PasswordVaultDetailData: {
    data: null,
    error: null,
  },
};

const PasswordVaultRedux = createSlice({
  name: "PasswordVault",
  initialState,
  reducers: {},

  extraReducers: (builder) => {
    builder
      .addCase(PasswordVaultgetlist.fulfilled, (state, action) => {
        state.PasswordVaultData.data = action.payload;
      })
      .addCase(PasswordVaultgetlist.rejected, (state, action) => {
        state.PasswordVaultData.error = action.error.message;
      })
      .addCase(PasswordVaultSave.fulfilled, (state, action) => {
        state.PasswordVaultSaveData.data = action.payload;
      })
      .addCase(PasswordVaultSave.rejected, (state, action) => {
        state.PasswordVaultSaveData.error = action.error.message;
      })
      .addCase(PasswordVaultDetail.fulfilled, (state, action) => {
        state.PasswordVaultDetailData.data = action.payload;
      })
      .addCase(PasswordVaultDetail.rejected, (state, action) => {
        state.PasswordVaultDetailData.error = action.error.message;
      });
  },
});

export default PasswordVaultRedux.reducer;
